import { Component, Host, h, Prop } from '@stencil/core';


@Component({
    tag: 'app-lazy-img',
    shadow: false,
})
export class AppLazyImg {

    @Prop() imgSrc: string;
    @Prop() imgAlt: string;
    @Prop() imgSrcWebp: string;
    @Prop() cssClass: string = '';

    componentDidLoad() {
        if (globalThis.imageLoader) {
            globalThis.imageLoader.initialize();
        }
    }

    render() {
        return (
            <Host>
                <picture>
                    <source class={`img-load-lazy ${this.cssClass}`} data-srcset={this.imgSrcWebp} type="image/webp" />
                    <source class={`img-load-lazy ${this.cssClass}`} data-srcset={this.imgSrc} />
                    <img class={`img-load-lazy ${this.cssClass}`} data-src={this.imgSrc} alt={this.imgAlt} role={!this.imgAlt ? 'presentation' : ''} />
                </picture>
            </Host>
        );
    }

}
